import React, { useRef } from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
import { useHistory } from 'react-router-dom';
import './PaymentReport.css'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ReactToPrint from 'react-to-print';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Col, Row } from 'reactstrap';
import Layout from '../NewHeader/Layout';
import { ButtonGroup, InputGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Dropdown, DropdownButton, Form } from 'react-bootstrap';
import DefaultProfileImage from '../../images/profile.png';
import Pagination from 'react-js-pagination';
import Table from 'react-bootstrap/Table';
import profile from '../../images/splash/avatar.png';


const ReportBillPrint = React.forwardRef(({ shopDetails, selectedDate, cashSales, totalPayout, otherTotal, totalSales,allCreditTotal }, ref) => (
    <div ref={ref} id='reportBill' style={{backgroundColor:"rgba(63, 68, 63, 0.082)",padding:"10px", maxWidth:"310px"}}>
      <div>
        <h3 style={{textAlign:"center",fontWeight:"lighter",textTransform:"uppercase",color:"black",fontFamily:"fantasy",letterSpacing: "3px"}}>{localStorage.getItem('shopName')}</h3>
        {/* Render shop details */}
        {shopDetails ? (
          <div style={{lineHeight: "15%",fontFamily:"cursive",marginTop:"15px"}}>
            <p style={{textAlign:"center", fontWeight:"bolder"}}>{shopDetails.address}</p>
            <p style={{textAlign:"center", fontWeight:"bolder"}}>{shopDetails.state}, {shopDetails.country_name}</p>
            <p style={{textAlign:"center", fontWeight:"bolder"}}>{shopDetails.user.mobile}</p>
          </div>
        ) : (
          <div>Loading...</div>
        )}
        <hr style={{border:"2px solid black"}}/>
        {/* Render report summary */}
        <p style={{textAlign:"center", fontWeight:"bolder", fontSize:"20px", fontFamily:"serif"}}>Report Summary</p>
        <p style={{textAlign:"left", fontWeight:"bolder",fontSize:"17px"}}>Date:<b>{selectedDate}</b> <span style={{float:"right"}}>Time:<b>{new Date().toLocaleTimeString()}</b></span></p>
        <br/>
        <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder"}}> Cash Sales: <span style={{float:"right"}}>{cashSales ? cashSales.toFixed(3) : 0}</span></h5>
        <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder"}}> Total Payout: <span style={{float:"right"}}>{totalPayout? totalPayout : 0}</span></h5>
        <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder"}}> Other Total: <span style={{float:"right"}}>{otherTotal ? otherTotal.toFixed(3) : 0}</span></h5>
        <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder"}}> All Credit Total: <span style={{float:"right",fontFamily:"monospace"}}>{allCreditTotal ? allCreditTotal.toFixed(3) : 0}</span></h5>
        <hr style={{border:"2px solid black"}}/>
        <h5 style={{fontFamily:"serif",color:"black",fontWeight:"bolder",fontSize:"22px"}}> Total Sales: <span style={{float:"right"}}>{totalSales ? totalSales.toFixed(3) : 0}</span></h5>
        <h5 style={{fontFamily:"serif",color:"black",marginTop:"20px", fontSize:"22px"}}> Balance Cash:{" "} <span style={{float:"right"}}>{( cashSales - totalPayout).toFixed(3)}</span></h5>
        <hr style={{border:"2px solid black"}}/>
        <div style={{marginTop:"-21px",lineHeight:"10px"}}>
          <br/>
          <h6 style={{textAlign:"center",fontFamily:"monospace",fontWeight:"bolder",color:"black",margin:"5px", fontSize:"19px"}}>Have a Nice Day...!</h6>
        </div>
      </div>
    </div>
  ));


const NewSettlement = () => {
  const getFirstDayOfCurrentMonths = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  };
  
  const getLastDayOfCurrentMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0);
  };
  
  const getStartOfWeek = () => {
    const now = new Date();
    const firstDay = now.getDate() - now.getDay(); // Adjust for Sunday
    return new Date(now.setDate(firstDay));
  };
  
  const getEndOfWeek = () => {
    const now = new Date();
    const lastDay = now.getDate() + (6 - now.getDay()); // Adjust for Saturday
    return new Date(now.setDate(lastDay));
  };
  
    const [selectedDate, setSelectedDate] = useState(getYesterdayDate());
    const [selectedDatepaymode, setSelectedDatepaymode] = useState(new Date().toISOString().split('T')[0]);
    const [tables, setTables] = useState([]);
    const [Normalsummary, setSummary] = useState([]);
    const [Creditsummary, setCreditSummary] = useState([]);

    
    
    const [paymode, setPaymode] = useState([]);
    const [creditPaymode, setCreditPaymode] = useState([]);
    const [ loading, setLoading ] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isLoading1, setIsLoading1] = useState(false); // Add isLoading state
    const [cashSales, setCashSales] = useState(null);
    const [otherTotal, setOtherTotal] = useState(null);
    const [totalPayout, setTotalPayout] = useState(null);
    const [totalSales, setTotalSales] = useState(null);
    const [allCreditTotal, setAllCreditTotal] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [shopDetails, setShopDetails] = useState(null);
    const history = useHistory();
    const valtoday = new Date().toISOString().split('T')[0];
    const componentRef = useRef(null); 
    const printingType = localStorage.getItem("printingType");
    const [filter, setFilter] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [refunds, setRefund] = useState([]);
    const [bookingOrder, setBookingorders] = useState([]);
    const [ itempopup, setItempopup ] = useState(false);
    const [ orderNo, setOrderNo ] = useState('');
    const [ updateId, setupdateId ] = useState('');
    const [ orderedItems, setorderItems ] = useState([]);
    const [ setOrdereditempopup, setOrderedItempopup ] = useState(false);

    const [showRefund, setShowRefund] = useState(false);
    const getFirstDayOfCurrentMonth = () => {
      const date = new Date();
      date.setDate(1); // Set the day to 1st to get the first day of the current month
      return date;
    };
    const [startDate, setStartDate] = useState(getFirstDayOfCurrentMonth());  // Set to the first day of the current month
    const [startDateTop, setStartDateTop] = useState(getFirstDayOfCurrentMonth());  // Set to the first day of the current month

const [endDate, setEndDate] = useState(new Date());
  // Format the date in DD-MM-YYYY format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = ("0" + date.getDate()).slice(-2);  // Add leading zero to day
    const month = ("0" + (date.getMonth() + 1)).slice(-2);  // Add leading zero to month
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;  // Return in DD-MM-YYYY format
  };


useEffect(() => {
  // Format dates before passing to API
  const formattedStartDate = formatDate(startDate);
  const formattedStartDate2 = formatDate(selectedDatepaymode);

  const formattedEndDate = formatDate(endDate);
  fetchTables(formattedStartDate2, formattedStartDate2);

  fetchNormalOrder(formattedStartDate2);
  fetchCreditOrder(formattedStartDate2);
}, [startDate, endDate,selectedDatepaymode]);  // Re-run the API call whenever startDate or endDate changes

const fetchTables = async (selectedStartDate, selectedEndDate) => {
  setLoading(true);
  const shop_id = localStorage.getItem('ShopId');
  const token = localStorage.getItem('Token');

  try {
    const response = await axios.get(
      `${var_api}booking-orders/payment-order-report/${shop_id}/${selectedStartDate}/${selectedEndDate}`,
      {
        headers: {
          Authorization: `${token}`, // Add the token to the Authorization header dynamically
        },
      }
    );
    setLoading(false);
    console.log("Response received:", response);
    const user = response.data.data;
    setTables(user);
  } catch (error) {
    setLoading(false);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error fetching data:", error);
    }
  }
};



const fetchNormalOrder = async (formattedStartDate2) => {
  setLoading(true);
  const shop_id = localStorage.getItem('ShopId');
  const token = localStorage.getItem('Token');

  try {
    const response = await axios.get(
      `${var_api}settlement/normal-order/${shop_id}/${formattedStartDate2}`,
      {
        headers: {
          Authorization: `${token}`, // Add the token to the Authorization header dynamically
        },
      }
    );
    setLoading(false);
    console.log("Response received:", response);
    const user = response.data.data;
    setCreditSummary(user);
  } catch (error) {
    setLoading(false);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error fetching data:", error);
    }
  }
};


const fetchCreditOrder = async (formattedStartDate2) => {
  setLoading(true);
  const shop_id = localStorage.getItem('ShopId');
  const token = localStorage.getItem('Token');

  try {
    const response = await axios.get(
      `${var_api}settlement/credit-order/${shop_id}/${formattedStartDate2}`,
      {
        headers: {
          Authorization: `${token}`, // Add the token to the Authorization header dynamically
        },
      }
    );
    setLoading(false);
    console.log("Response received:", response);
    const user = response.data.data;
    setSummary(user);
  } catch (error) {
    setLoading(false);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error fetching data:", error);
    }
  }
};



const handleSelect = (e) => {
  setFilter(e);

  if (e === 'Daily') {
    const today = new Date();
    setStartDate(today);
    setEndDate(today);
  } else if (e === 'Weekly') {
    setStartDate(getStartOfWeek());
    setEndDate(getEndOfWeek());
  } else if (e === 'Monthly') {
    setStartDate(getFirstDayOfCurrentMonths());
    setEndDate(getLastDayOfCurrentMonth());
  } else if (e === 'Choose Date') {
    setShowModal(true);
  }
};
      const handleClose = () => setShowModal(false);

    const handleFilterChange = (selectedFilter) => {
      setFilter(selectedFilter);
    };
  

    const fetchShopDetails = () => {
        const shopID = localStorage.getItem('shopId');
  // Make the API request
  axios
    .get(`${var_api}/api/shop/shopDetails/${shopID}`)
    .then((response) => {
      setShopDetails(response.data)
      console.log("shop details:",response.data, shopDetails)
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
    });
    }
    

    const totalAmount = paymode.reduce((total, item) => total + (item.total_Amount || 0), 0);

function getYesterdayDate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const dd = String(yesterday.getDate()).padStart(2, '0');
    const mm = String(yesterday.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = yesterday.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
}


const handleDateChangepaymode = (e) => {
    setSelectedDatepaymode(e.target.value);
};



const formatDateForInputField = (dateString) => {
    const [yyyy, mm, dd] = dateString.split('-');
    return `${dd}-${mm}-${yyyy}`; // Format as dd-mm-yyyy
};


const showToast = (message) => {
    // Implement toast message display logic here
    alert(message);
};


const handleButtonClickhome = () => {
    // Navigate to a specific route using history.push
    history.push('/home');
  };


  const handlePrintOpenModal = () => {
   setIsOpen(true);
  };



  const handlePrints = async () => {
    try {
        // Get the reference to the ReportBillPrint component
        const component = componentRef.current;

        if (!component) {
            console.error('Component reference not found.');
            return;
        }

        // Ensure the component is fully rendered before capturing
        await new Promise(resolve => setTimeout(resolve, 1000)); // Adjust timeout as needed

        // Capture the component as an image using html2canvas
        const canvas = await html2canvas(component, {
            scale: 2, // Adjust scale for better quality
            useCORS: true // Ensure cross-origin images are captured properly if needed
        });

        // Convert the canvas to an image (PNG format by default)
        const imgData = canvas.toDataURL('image/png');

        // Calculate dimensions for PDF creation
        const imgWidth = 1.98; // Width in inches
        const imgHeight = (canvas.height / canvas.width) * imgWidth; // Maintain aspect ratio

        // Create a new jsPDF instance for PDF generation
        const pdf = new jsPDF({
            orientation: 'portrait', // Set orientation (portrait or landscape)
            unit: 'in', // Set unit of measurement
            format: [imgWidth, imgHeight] // Set dimensions of the PDF
        });

        // Add the image captured from canvas to the PDF
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

        // Convert the PDF to base64 data URI
        const pdfData = pdf.output('datauristring');
        const printerName = localStorage.getItem("selectedPrinter");

        // Send the base64 PDF data to the backend for printing
        await axios.post('http://localhost:3001/print', {
            data: pdfData.split(',')[1] ,// Extract base64 data from the URI
            printerName: printerName
        });

    } catch (err) {
        console.error('Error printing:', err);
    }
};
const handleRefund = (items) => {
  setRefund(items);
  setShowRefund(true);
};
const handleCloseRefund = () => setShowRefund(false);
const getStatusDetails = (status) => {
  switch (status) {
    case 1:
      return { text: "Approved", color: "green" };
    case 2:
      return { text: "Cancelled", color: "red" };
    default:
      return { text: "New", color: "blue" };
  }
};

const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); // Number of items per page
const [searchTerm, setSearchTerm] = useState('');

// Filtering tables based on search term
const filteredTables = tables.filter((item) => {
  // Map status, payment status, and order type to readable text
  const approvalStatusText = (() => {
    switch (item.approval_status) {
      case 1:
        return "Approved";
      case 2:
        return "Cancelled";
      default:
        return "New";
    }
  })();

  const paymentStatusText = item.payment_status === 0 ? "Not Paid" : "Paid";

  const orderTypeText =
    item.order_type === 1
      ? "Normal Order"
      : item.order_type === 2
      ? "Credit Order"
      : "-";


      const orderStatusText =
      item.order_status === 0 ? "New" :
      item.order_status === 1 ? "Partial" :
      item.order_status === 2 ? "Delivered" :
      item.order_status === 4 ? "Cancelled" : "Cancelled";


  const refund =
    item.is_refund === 1
      ? "Refunded"
      :  "Not Refunded";

  const safeString = (value) => (value ? String(value).toLowerCase() : ""); // Safely handle undefined values

  return (
    safeString(item.customer_name).includes(searchTerm.toLowerCase()) ||
    safeString(item.mobile_no).includes(searchTerm.toLowerCase()) ||
    safeString(item.order_no).includes(searchTerm.toLowerCase()) ||
    safeString(item.delivery_address).includes(searchTerm.toLowerCase()) ||
    safeString(item.slot_name).includes(searchTerm.toLowerCase()) ||
    safeString(item.delivery_date).includes(searchTerm.toLowerCase()) ||
    safeString(item.amount).includes(searchTerm.toLowerCase()) ||
    safeString(approvalStatusText).includes(searchTerm.toLowerCase()) ||
    safeString(paymentStatusText).includes(searchTerm.toLowerCase()) ||
    safeString(orderTypeText).includes(searchTerm.toLowerCase()) ||
    safeString(refund).includes(searchTerm.toLowerCase()) || 
    safeString(orderStatusText).includes(searchTerm.toLocaleLowerCase())
  );
});




// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
const totalItems = filteredTables.length;

const handleSearchInput = (event) => {
  setSearchTerm(event.target.value);
  setCurrentPage(1); // Reset to the first page when search changes
};

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

const sumAmounts = (array) => {
  return array.reduce((total, item) => total + item.amount, 0);
};

const normalOrderTotal = sumAmounts(Normalsummary);
const creditOrderTotal = sumAmounts(Creditsummary);
const grandTotal = normalOrderTotal + creditOrderTotal;

const handleshow =(data,dataId)=>{
  setBookingorders(data);
  setItempopup(true);
  localStorage.setItem('SelectedBookingId', dataId);
}

const handelOrderNo =(data)=>{
  setOrderNo(data.order_no);
  setupdateId(data.id);
  console.log(orderNo +'---'+updateId)
}

const handleshowItems =(data)=>{
  setorderItems(data);
  setOrderedItempopup(true);
}

    return(
        <>
        <Layout>
        <div  style={{backgroundColor:"white",width: "100%" }}  >

            {/* <div style={{ textAlign: "center" }}>
        <nav className="navbar" style={{ boxShadow: "0px 0px 1px 0px black", backgroundColor: "green", border: "none", padding: "5px", height: "50px", width: "100%", display: "flex",justifyContent:'space-around'}}>
                <h3 style={{ fontFamily: "cursive", fontWeight: "bolder", color: "white" }}>SETTLEMENT</h3>
                <button className="btn" onClick={handleButtonClickhome} style={{ backgroundColor: "white", color: "green" }}>
                    <i class="bi bi-house"></i> Go to Home
                </button>
        </nav>
    </div> */}
    
    {/* <br/> */}
    {/* New design */}
   

 
   
        {/* newdesgin */}
        <div style={{margin:"0px 50px"}}>
     
        <div style={{  display: 'flex', flexDirection:"column" }}>
        <h4 className='ushe'>Admin Payment Report</h4>
        <br></br>
<div className="card" style={{ maxWidth: '300px'}}>
  
        <div className="card-body" style={{ display: 'flex', flexDirection: 'row', alignItems: 'right'}}>
            <p className="card-text" style={{ marginRight: '10px',fontWeight:"bolder" }}>Date: </p>
            <i className="bi bi-search" style={{ marginRight: '5px'}}></i>
            <input 
            type="date" 
            id="yesterdayDateInput" 
            className="form-control" 
            style={{ marginRight: '5px',  color:"blue"}}
            value={selectedDatepaymode}
            onChange={handleDateChangepaymode}
            max={valtoday} // Setting the max attribute to today's date
        />
        </div>
    </div>
    </div>
        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px', padding: '20px' }}>

    <div style={{ flex: '1' }}>
           {/* Credit Order Balance Amount Collection Card */}
    <div style={{ width: '100%' }}>
        {isLoading ? (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        ) : (
            <>
        <h6 style={{ fontWeight: "bolder", textAlign: "center", color: "green" }}>Normal Order </h6>
        <div className="card" style={{ width: '100%', height: "auto", border: "2px solid green" }}>
        <div className="card-body">
  <div
    style={{
      borderBottom: "2px solid black",
      paddingBottom: "10px",
      marginBottom: "10px",
    }}
  >
    <div
      className="card-title"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <div style={{ flex: "1", textAlign: "left" }}>
        <strong>Paymode</strong>
      </div>
      <div style={{ flex: "1", textAlign: "left" }}>
        <strong>Amount</strong>
      </div>
    </div>
  </div>

  {Creditsummary.length === 0 ? (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      No Credit Orders
    </div>
  ) : (
    <>
      {Creditsummary.map((table, index) => (
        <div
          key={index}
          className="content"
          style={{
            borderBottom: "1px solid black",
            paddingBottom: "5px",
            marginBottom: "5px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ flex: "1", textAlign: "left" }}>{table.paymode_name}</div>
          <div style={{ flex: "1", textAlign: "left" }}>${table.amount}</div>
        </div>
      ))}

      {/* Full Total */}
      <div
        className="total"
        style={{
          paddingTop: "10px",
          marginTop: "10px",
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
      >
        <div style={{ flex: "1", textAlign: "left" }}>Total</div>
        <div style={{ flex: "1", textAlign: "left" }}>
          $
          {Creditsummary.reduce(
            (total, item) => total + item.amount,
            0
          ).toFixed(2)}
        </div>
      </div>
    </>
  )}
</div>

        </div>
        </>
        )}
    </div>
    </div>





    <div style={{ flex: '1' }}>
    <div style={{ width: '100%' }}>
        {isLoading ? (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        ) : (
            <>
   
        <h6 style={{ fontWeight: "bolder", textAlign: "center", color: "green" }}>Credit Order</h6>
        <div className="card" style={{ width: '100%', height: "auto", border: "2px solid green" }}>
        <div className="card-body">
  <div
    style={{
      borderBottom: "2px solid black",
      paddingBottom: "10px",
      marginBottom: "10px",
    }}
  >
    <div
      className="card-title"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <div style={{ flex: "1", textAlign: "left" }}>
        <strong>Paymode</strong>
      </div>
      <div style={{ flex: "1", textAlign: "left" }}>
        <strong>Amount</strong>
      </div>
    </div>
  </div>
  {Normalsummary.length === 0 ? (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      No Normal Orders
    </div>
  ) : (
    <>
      {Normalsummary.map((table, index) => (
        <div
          key={index}
          className="content"
          style={{
            borderBottom: "1px solid black",
            paddingBottom: "5px",
            marginBottom: "5px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ flex: "1", textAlign: "left" }}>
            {table.paymode_name}
          </div>
          <div style={{ flex: "1", textAlign: "left" }}>${table.amount}</div>
        </div>
      ))}
      {/* Full Total */}
      <div
        className="total"
        style={{
          paddingTop: "10px",
          marginTop: "10px",
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
      >
        <div style={{ flex: "1", textAlign: "left" }}>Total</div>
        <div style={{ flex: "1", textAlign: "left" }}>
          $
          {Normalsummary.reduce((total, item) => total + item.amount, 0).toFixed(
            2
          )}
        </div>
      </div>
    </>
  )}
</div>

        </div>
        </>
        )}
        </div>
    </div>
  

    <div style={{ flex: '1'}}>
    <div style={{ width: '100%' }}>
        {isLoading ? (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        ) : (
            <>
        <h6 style={{ fontWeight: "bolder", textAlign: "center", color: "green" }}>Summary Report</h6>
        <div className="card" style={{ width: '100%', height: "auto", border: "2px solid green", margin: "auto" }}>
            <div className="card-body">
                <h5 style={{ fontFamily: "serif", color: "black", fontWeight: "normal" }}>Normal Order Sales: <span style={{ float: "right", fontFamily: "monospace" }}>${creditOrderTotal}</span></h5>
                <h5 style={{ fontFamily: "serif", color: "red", fontWeight: "normal" }}>Credit Order Sales: <span style={{ float: "right", fontFamily: "monospace" }}>${normalOrderTotal}</span></h5>
               
                <hr />
                <h5 style={{ fontFamily: "serif", color: "green", fontWeight: "bolder" }}>Total Sales: <span style={{ float: "right", fontFamily: "monospace" }}>${grandTotal}</span></h5>
                {/* <h5 style={{ fontFamily: "serif", color: "green", marginTop: "20px" }}>Balance Cash: <span style={{ float: "right", fontFamily: "monospace" }}>{(cashSales - totalPayout).toFixed(3)}</span></h5> */}
            </div>
        </div>
        </>
        )}
    </div>
      
  
    </div>
    
</div>
<div
  style={{
    padding: "20px",
    width: "100%",
    margin: "auto",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Light shadow for depth
    border: "1px solid #e0e0e0",  // Optional: Add a subtle border
  }}
>
  
      <div className="d-flex justify-content-end mt-4 mb-4">
      {/* <DropdownButton
        id="dropdown-basic-button"
        title={filter || 'Filter'}
        onSelect={handleSelect}
        variant="outline-secondary"
      >
        <Dropdown.Item eventKey="Daily">Daily</Dropdown.Item>
        <Dropdown.Item eventKey="Weekly">Weekly</Dropdown.Item>
        <Dropdown.Item eventKey="Monthly">Monthly</Dropdown.Item>
        <Dropdown.Item eventKey="Choose Date">Choose Date</Dropdown.Item>
      </DropdownButton>        */}


      {/* <div style={{ display: "flex", flexDirection: "row",gap:"40px",alignItems:'center' }}>
          <div style={{ display: "flex", flexDirection: "row",gap:"10px",alignItems:'center' }}>
                      <lable  className="form-label m-0">START DATE:</lable>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholderText="Start Date"
                        className="form-control m-0"
                        style={{ marginRight: '10px', borderRadius: '8px' }}
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" ,gap:"10px",alignItems:'center'}}>
                      <lable className="form-label  m-0">END DATE:</lable>

                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholderText="End Date"
                        className="form-control m-0"
                        style={{ marginRight: '10px', borderRadius: '8px' }}
                      />
                    </div>
                    </div> */}
     <input
    className="form-control"
    type="text"
    placeholder="Search"
    style={{ width: "20%" }}
    onChange={handleSearchInput}
  />
        </div>
     
      <div className="table-container" style={{ height: 'auto', overflowY: 'auto', marginTop: '10px' }}>
        <table className="table caption-top" style={{ borderColor: 'grey', width: '100%', margin: 'auto' }}>
          <thead>
            <tr style={{ fontWeight: 'bold' }}>
            <th style={{ textAlign: 'left' }}>S.No</th>
                  <th style={{ textAlign: 'left' }}>Customer Name</th>
                  <th style={{ textAlign: 'left' }}>Mobile</th>
                  <th style={{ textAlign: 'left' }}>Order Id</th>
                  <th style={{ textAlign: 'left' }}>Order Date</th>
                  <th style={{ textAlign: 'left' }}>Order Type</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Delivery Person</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Delivered Address</th>
                  <th style={{ textAlign: 'left' }}>Amount</th>                  
                  <th style={{ textAlign: 'left' }}>Order Status</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Payment Status</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Refund Status</th>
                  <th style={{ textAlign: 'left' }}>view</th>
            </tr>
          </thead>
          {loading ? (
            <div className="loader-container">
              <div className="spinner"></div>
            </div>
          ) : (
            <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((order, index) => (
                <tr>
                  <th scope="row">{index + 1}</th>
                  <td>{order.customer_name}</td>
                  <td>{order.mobile_no}</td>
                  <td>{order.order_no}</td>
                  <td>{order.order_date}</td>
                  <td style={{ textTransform: "capitalize", textAlign: "left", color: "blue", fontWeight: "bold" }}>
                    {order.order_type === 1 ? "Normal Order" : order.order_type === 2 ? "Credit Order" : "-"}
                  </td>
                         <td style={{ textTransform: "capitalize", textAlign: "left", display: "flex", alignItems: "center", gap: "10px",borderBottom:'none' }}>
                  
                    <img
                      src={order.delivery_person_profile ? `${image_api}/${order.delivery_person_profile}` : DefaultProfileImage}
                      alt="profile"
                      width="65px"
                      height="60px"
                      style={{ borderRadius: "8px", objectFit: "cover" }}
                    />
                      <div>
                      {order.delivery_person_name || "-"}
                    </div>
                  </td>
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                    {order.delivery_address || "-"}
                  </td>
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                    ${order.amount || "-"}
                  </td>

                  <td style={{
                          textAlign: "left",
                          color: order.order_status === 0 ? "blue" :
                          order.order_status === 1 ? "orange" :
                          order.order_status === 2 ? "green" :
                          order.order_status === 3 ? "red" : "gray",
                          fontWeight: "bold",
                        }}>
                         {order.order_status === 0 ? "New" :
                         order.order_status === 1 ? "Partial" :
                         order.order_status === 2 ? "Delivered" :
                         order.order_status === 4 ? "Cancelled" : "Cancelled"}
                         </td>

                  <td style={{
                    textAlign: "left",
                    color: order.payment_status === 0 ? "red" : "green",
                    fontWeight: "bold"
                  }}>
                    {order.payment_status === 0 ? "Not Paid" : "Paid"}

                  </td>
                 
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
  {order.is_refund === 1 ? (
    <button  onClick={() => handleRefund(order)} className="btn btn-success btn-sm" style={{ fontSize: "14px" }}>
      Refunded
    </button>
  ) : (
    <button className="btn btn-secondary btn-sm" style={{ fontSize: "12px" }} disabled>
      Not Refunded
    </button>
  )}
</td>
<td>
          <div style={{ textAlign: "left", display: "flex", gap: "2px" }}>
            <button
              className="btn btn-primary"
              onClick={() => {
                handleshow(order.booking_dates,order.id);
                handelOrderNo(order);
              }}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
            </button>
            </div>
            </td>



                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="16" style={{ textAlign: "center", color: "red", fontWeight: "bold", borderColor: "black" }}>
                  No Payments Found
                </td>
              </tr>
            )}
          </tbody>
          )}
        </table>
        <Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
    </div>

      </div>
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Date Range</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* From Date Picker */}
          <div style={{ display: "flex", flexDirection: "column", marginBottom: '10px' }}>
            <label className="form-label mb-2">From Date</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              placeholderText="Start Date"
              className="form-control"
              style={{ borderRadius: "8px" }}
            />
          </div>

          {/* To Date Picker */}
          <div style={{ display: "flex", flexDirection: "column", marginBottom: '10px' }}>
            <label className="form-label mb-2">To Date</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              placeholderText="End Date"
              className="form-control"
              style={{ borderRadius: "8px" }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary">
            SEARCH
          </Button> */}
        </Modal.Footer>
      </Modal>
        <Modal
        show={isOpen}
        onHide={()=>setIsOpen(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header closeButton >
          {/* <Modal.Title>confirmation</Modal.Title> */}Print Report Summary
        </Modal.Header>
        <Modal.Body>

        <ReportBillPrint
          ref={componentRef}
          shopDetails={shopDetails}
          selectedDate={selectedDate}
          cashSales={cashSales}
          totalPayout={totalPayout}
          otherTotal={otherTotal}
          totalSales={totalSales}
          allCreditTotal = {allCreditTotal}
        />

          <Button variant="danger" style={{float:"right"}} onClick={()=>setIsOpen(false)}>
            Close
          </Button>{' '} 

          {
            printingType == "directPrint" ?  (
                <button className='btn btn-success'  style={{ borderRadius: '5px', border: 'none', margin: '5px',float:"right" }} onClick={handlePrints}><i className='bi bi-printer-fill'></i> Print Directly</button>
            ) : (
          
          <ReactToPrint
          trigger={() => (
            <Button variant="primary" style={{float:"right",marginRight:"5px"}}>
              <i className="bi bi-printer-fill"></i> Print via Google
            </Button>
          )}
          content={() => componentRef.current}
        />
            )}
         
        </Modal.Body>
       
      </Modal>
      <Modal show={showRefund} onHide={handleCloseRefund} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>REFUND DETAILS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <table className="table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Refund Date</th>

                  <th>Refund Amount</th>
                  <th>Refund Status</th>

                  <th>Transaction ID</th>
                  <th>Refund Remarks</th>
                  <th>Refund Status</th>

                  {/* <th>Remarks</th> */}
                </tr>
              </thead>
              <tbody>
                  <tr >
                    <td>{ 1}</td>
                
                    <td>{refunds.refund_date}</td>
                    <td>{"$"+refunds.refund_amount}</td>

                   
                    <td>{refunds.refund_transaction_id}</td>
                    <td>{refunds.refund_remarks}</td>
                    <td>{refunds.refund_remarks}</td>

                    <td  style={{
                    textAlign: "left",
                    color: refunds.refund_status === 1 ? "green" : "red",
                    fontWeight: "bold"
                  }}>
                    {refunds.refund_status === 1
                      ? "Refunded"
                      : refunds.refund_status === 2
                        ? "Refund Failed"
                        : "-"}
                  </td>
                  </tr>
              </tbody>
            </table>
         
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseRefund}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
  show={itempopup}
  onHide={() => setItempopup(false)}
  backdrop="static"
  keyboard={false}
  size="xl"
>
  <Modal.Header closeButton>
    <Modal.Title>Delivery Dates (Order No - {orderNo})</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
        <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">From Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">To Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Person</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>

          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">View List</th>


        </tr>
      </thead>
      <tbody >
  {bookingOrder.length > 0 ? (
        (() => {
          let serialCounter = 1; // Initialize counter for Serial No
          return bookingOrder.map((dateItem, dateIndex) =>
      dateItem.slots.length > 0 ? (
        dateItem.slots.map((slot, slotIndex) => (
          <tr key={`${dateIndex}-${slotIndex}`} style={{borderBottom:"0.5px solid black"}}>
       
            <td>{serialCounter++}</td>
            <td>{dateItem.date}</td>
            <td>{slot.slot_name}</td>
            <td>{slot.from_time}</td>
            <td>{slot.to_time}</td>
            <td
 style={{
  textAlign: "center",
  display: "flex",
  borderTop: "none",
  borderBottom: "none",
  alignItems:'center',

  gap: "20px",
  alignContent: "center",
  // marginTop: "11px",
  height: "100px",
}}
>
  {slot.slot_delivery_person_name ? (
    <>
      {slot.slot_delivery_person_profile && (
        <img
          src={profile}
          alt="profile"
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      )}
      {slot.slot_delivery_person_name}
    </>
  ) : (
    "-"
  )}
</td>
            <td style={{
          textAlign: "left",
          color: slot.slot_status === 0 ? "blue" :
          slot.slot_status === 1 ? "orange" :
          slot.slot_status === 2 ? "green" :
          slot.slot_status === 3 ? "red" : "gray",
          fontWeight: "bold",
        }}>
          {slot.slot_status === 0 ? "New" :
           slot.slot_status === 1 ? "Inprogress" :
           slot.slot_status === 2 ? "Packed" :
           slot.slot_status === 3 ? "Delivered" : "Cancelled"}
        </td>
            <td>
              <button className="btn btn-primary" onClick={() => handleshowItems(slot.order_items)}>
                <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
              </button>
            </td>

          </tr>
        ))
      ) : (
        <tr key={dateIndex}>
          <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
            No data available
          </td>
        </tr>
      )
    );
  })()
  ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>

<Modal
  show={setOrdereditempopup}
  onHide={() => setOrderedItempopup(false)}
  backdrop="dynamic"
  keyboard={false}
  size="lg"
  fullscreen="sm-down" // Makes it responsive for small devices
  style={{ bottom: "0", marginTop: "auto" }} // Adjusts position
>
  <Modal.Header closeButton>
    <Modal.Title>Items</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Image</th>
          <th>Food Name</th>
          <th>Item Code</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Variant Name</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {orderedItems.length > 0 ? (
          orderedItems.map((item, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
              <td>{index + 1}</td>
              <td>
                <img
                  src={`${image_api}/${item.food_image}`}
                  alt="item_image"
                  width="50px"
                  height="50px"
                />
              </td>
              <td>{item.food_name}</td>
              <td>{item.item_code}</td>
              <td>{item.quantity}</td>
              <td>{item.unit_price}</td>
              <td>{item.variant_name}</td>
              <td>{item.remark}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </Modal.Body>
</Modal>

        </div>
        </Layout></>
  

        
    )
}

export default NewSettlement;